// extracted by mini-css-extract-plugin
export default {"wrapper":"side-actions_wrapper__5Vs7y"};